import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=7b229e6e"
import script from "./organizations.ts?vue&type=script&lang=js&external"
export * from "./organizations.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports